import React from "react";
import MarketingHeader from "@/components/MarketingHeader";
import { leads } from "@/lib/api";
import { COMMUNITY_CATEGORIES, COMMUNITY_THREADS } from "@/lib/communityContent";

export default function Community() {
  const [email, setEmail] = React.useState("");
  const [state, setState] = React.useState("idle");

  const notify = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) return;
    setState("sending");
    try {
      await leads.create(value, "community-waitlist");
      setState("done");
    } catch {
      setState("idle");
    }
  };

  return (
    <div className="mkt-page" data-testid="page-community">
      <MarketingHeader />

      <section className="mkt-hero">
        <div className="mkt-eyebrow">◢ COMMUNITY</div>
        <h1 className="mkt-h1">Ask questions. Trade notes. Learn from other GovCo.AI users.</h1>
        <p className="mkt-sub">
          A place for proposal managers, contributors, and small-business owners using GovCo.AI to help
          each other win more work.
        </p>
      </section>

      <section className="mkt-body">
        <div className="community-banner" data-testid="community-banner">
          <div>
            <div className="community-banner-title">The forum is launching soon</div>
            <div className="community-banner-sub">Here's a preview of what it'll look like. Leave your email and we'll let you know the day it opens.</div>
          </div>
          {state === "done" ? (
            <div className="community-banner-done" data-testid="community-notify-done">You're on the list 🎉</div>
          ) : (
            <form className="community-banner-form" onSubmit={notify}>
              <input
                type="email"
                placeholder="you@agency.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Work email"
                data-testid="community-notify-email"
              />
              <button className="btn btn-primary" type="submit" disabled={state === "sending"} data-testid="community-notify-submit">
                {state === "sending" ? "…" : "Notify me"}
              </button>
            </form>
          )}
        </div>

        <div className="community-layout">
          <aside className="community-categories" aria-label="Categories">
            <h2 className="mkt-h3">Categories</h2>
            {COMMUNITY_CATEGORIES.map((c) => (
              <div className="community-cat" key={c.name}>
                <span>{c.name}</span>
                <span className="community-cat-count">{c.threads}</span>
              </div>
            ))}
          </aside>

          <div className="community-threads">
            <h2 className="mkt-h3">Recent threads <span className="pill-soon">Illustrative preview</span></h2>
            {COMMUNITY_THREADS.map((t) => (
              <div className="community-thread" key={t.title}>
                <div className="community-thread-main">
                  <span className="community-thread-title">{t.title}</span>
                  <span className="community-thread-meta">{t.author} · {t.category}</span>
                </div>
                <div className="community-thread-replies">{t.replies} replies</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
